import React from 'react';
import { Form } from 'react-bootstrap';
import { questionIconSmall } from "../../../img/font_awesome/font_awesome.js"
import PasswordField from './PasswordField.js';

export default class TextField extends React.Component {
    
    render() {
        let placeholder = this.props.formGroup.placeholder;
        if (!placeholder) {
            placeholder = '(Optional)'
        }

        let style = this.props.formGroup.style;
        if (this.props.formGroup.fieldType === 'number') {
            style = {...style, textAlign: 'right'};
        }
        if (this.props.formGroup.fullWidth === true) {
            style = {...style, fontSize: '16px'};
        }

        let numberType = this.props.formGroup.numberType;
        let step = 1;
        if (numberType === 'decimal') {
            step = 0.01;
        } 

        let maxLength = this.props.formGroup.maxLength;
        if (!maxLength) {
            maxLength = 999; // arbitrary max length
        }

        let minLength = this.props.formGroup.minLength;
        if (!minLength) {
            minLength = 0; 
        }

        let maxValue = this.props.formGroup.maxValue;
        if (!maxLength) {
            maxLength = undefined;
        }

        let minValue = this.props.formGroup.minValue;
        if (!minValue) {
            minValue = 0;
        }

        let hintLink = <></>
        if (this.props.formGroup.hintLink) {
            hintLink = <span><a target="_blank" rel="noopener noreferrer" href={this.props.formGroup.hintLink} aria-label='More Info' style={{ color: '#3675A5', fontWeight: 'bold' }}>{questionIconSmall}</a></span>
        }

        let errorClassName = this.props.formGroup.error === true ? 'field-error' : undefined;

        let formControl =   <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} type={this.props.formGroup.fieldType} minLength={minLength} maxLength={maxLength} min={minValue} max={maxValue} step={step} precision={2} placeholder={placeholder} disabled={this.props.disabled} onChange={this.props.onChange} onBlur={this.props.formGroup.onBlur} value={this.props.formGroup.value}/>
        if (this.props.formGroup.required === true) {
            if (this.props.formGroup.fieldType === 'tel') {
                formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} required type='tel' maxLength='14' pattern="(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}" disabled={this.props.disabled} onChange={this.props.onChange} value={this.props.formGroup.value}/>
            } if (this.props.formGroup.fieldType === 'tel_international') {
                formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} required maxLength='15' disabled={this.props.disabled} onChange={this.props.onChange} value={this.props.formGroup.value}/>
            } else if (this.props.formGroup.fieldType === 'zip') {
                formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} required type='text' maxLength='5' disabled={this.props.disabled} onChange={this.props.onChange} value={this.props.formGroup.value}/>
            } else if (this.props.formGroup.fieldType === 'password') {
                formControl =   <PasswordField ref={this.props.skipLinkRef} className={errorClassName} autoComplete={this.props.formGroup.autoComplete} passwordRules={this.props.formGroup.passwordRules} style={style} minLength={minLength} maxLength={maxLength} disabled={this.props.disabled} onChange={this.props.onChange} onBlur={this.props.formGroup.onBlur} value={this.props.formGroup.value}></PasswordField>
            } else {
                formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} required type={this.props.formGroup.fieldType} minLength={minLength} maxLength={maxLength} min={minValue} max={maxValue} step={step} precision={2} disabled={this.props.disabled} onChange={this.props.onChange} onBlur={this.props.formGroup.onBlur} value={this.props.formGroup.value}/>
            }
        } else if (this.props.formGroup.disableField == true) {
            formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} id={this.props.formGroup.id} disabled type={this.props.formGroup.fieldType} precision={2} onChange={this.props.onChange} value={this.props.formGroup.value}/>
        } else if (this.props.formGroup.fieldType === 'tel') {
            formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} type='tel' maxLength='14' pattern="(?:\(\d{3}\)|\d{3})[- ]?\d{3}[- ]?\d{4}" disabled={this.props.disabled} placeholder={placeholder} onChange={this.props.onChange} value={this.props.formGroup.value}/>
        } else if (this.props.formGroup.fieldType === 'tel_international') {
            formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} type='text' maxLength='15' disabled={this.props.disabled} placeholder={placeholder} onChange={this.props.onChange} value={this.props.formGroup.value}/>
        } else if (this.props.formGroup.fieldType === 'zip') {
            formControl =  <Form.Control ref={this.props.skipLinkRef}  className={errorClassName} style={style} type='text' maxLength='5' disabled={this.props.disabled} placeholder={placeholder} onChange={this.props.onChange} value={this.props.formGroup.value}/>
        }

        let fontWeight = 'normal';
        if (this.props.formGroup.primaryCriteria) {
            fontWeight = 'bold';
        }

        let label = this.props.formGroup.label ? this.props.formGroup.label + ':' : <>&nbsp;</>;
        let leadingCharacter = this.props.formGroup.fieldType === 'tel_international' ? '+' : '';
        let mobileLabelStyle = this.props.formGroup.fullWidth ? { fontSize: '13px', fontWeight: 'bold', color: '#114E6B' } : undefined;
        return (
            <div style={{  marginLeft: this.props.formGroup.fullWidth ? 0 : 4, fontWeight }}>
                 <div><label style={mobileLabelStyle} for={this.props.formGroup.labelFor}>{label}</label><span style={{cursor: 'pointer'}}>&nbsp;{hintLink}</span></div>
                <div style={{display: 'flex', alignItems : 'center'}}><span>{leadingCharacter}</span> {formControl} </div>
            </div>
        )
    }
}